import React from 'react';
import { IPScrollablePane, IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { IPTextField } from 'baseComponents/TextField/IPTextField';
import RichTextEditor from 'components/Text/RichTextEditor';
import { globalStackItemStylesPaddingSceneScroll, globalStackTokensGapSmall, globalTextFieldBig } from 'globalStyles';
import Task from 'models/tasks/task';
import { useTranslation } from 'react-i18next';
import AppContext from 'App/AppContext';
import { TaskTagList } from 'components/Tasks/TaskTagList';
import Tag from 'models/tag';
import { TaskState } from 'models/tasks/taskHelperClasses';

interface IOutlookEventTaskDetail {
  task: Task;
  orgTask: Task;
  getErrorMessage: (field: string) => string | undefined;
  onUpdate: (newTask: Task) => void;
  taskStates: TaskState[];
  isActionPending: boolean;
  tags: Tag[];
  addTagToTaskState: (tag: Tag) => void;
  removeTagFromTaskState: (tag: Tag) => void;
  createTagState: (tag: Tag) => void;
  onChangeCompletionDate: (completionDate: Date) => void;
}

export const OutlookEventTaskDetail = (props: IOutlookEventTaskDetail) => {
  const appContext = React.useContext(AppContext);
  const { t } = useTranslation(['task', 'control', 'translation']);

  //
  // Main render
  //
  return (
    <IPStack verticalFill tokens={globalStackTokensGapSmall}>
      <IPStack.Item grow styles={globalStackItemStylesPaddingSceneScroll}>
        <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>
          <IPStack verticalFill tokens={globalStackTokensGapSmall}>
            <IPStack.Item>
              <IPTextField
                underlined
                autoFocus={!appContext.isMobileView}
                value={props.task.name ? props.task.name : ''}
                styles={globalTextFieldBig}
                onGetErrorMessage={(value) => {
                  if (value === '') return '';

                  return props.getErrorMessage('name');
                }}
                placeholder={t('task:Title.Placeholder')}
                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                  let copyTask = props.task.clone();
                  copyTask.name = newValue ? newValue : '';
                  props.onUpdate(copyTask);
                }}
                maxLength={512}
              />
            </IPStack.Item>
            <IPStack.Item>
              <TaskTagList
                tags={props.tags}
                isLoading={props.isActionPending}
                addTagToTaskState={props.addTagToTaskState}
                removeTagFromTaskState={props.removeTagFromTaskState}
              />
            </IPStack.Item>
            <IPStack.Item>
              <RichTextEditor
                html={props.task.description}
                onChange={(value: string) => {
                  let copyTask = props.task.clone();
                  copyTask.description = value;
                  props.onUpdate(copyTask);
                }}
                placeholder={t('task:Description.Placeholder')}
                maxLength={8000}
                readOnly={false}
                maxHeight={300}
                directEdit={true}
              />
            </IPStack.Item>
          </IPStack>
        </IPScrollablePane>
      </IPStack.Item>
    </IPStack>
  );
};
